import ActionTypes from './actionTypes';

export function getAccountsRequest(accountNumber, grandParentAccountNumber, pageSize=10, pageNum=1, sortBy='AccountLevel', sortOrder=false, searchTerm='', actionType=ActionTypes.ACCOUNTS.REQUEST) {
  return {
    type: actionType,
    payload: {
      accountNumber,
      grandParentAccountNumber,
      contractSearchMethod: 'CONTRACT_NUMBER',
      pageSize: pageSize,
      outObjectPage: pageNum,
      sortBy: sortBy,
      sortOrder: sortOrder ? 'Asc' : 'Desc',
      searchTerm: searchTerm
    },
  };
}

export function getAllAccountsRequest(accountNumber, grandParentAccountNumber) {
  return getAccountsRequest(accountNumber, grandParentAccountNumber, 0, 0, undefined, undefined, undefined, ActionTypes.ACCOUNTS.ALL.REQUEST);
}

export function getAccountsSuccess(actionType, response) {
  return {
    type: actionType,
    payload: {
      accounts: response.getContractListByContract,
      totalSize: response.outObjectCount, //TODO this need to be sent out from Way4 API total call
      hierarchy: response.hierarchy,
    }
  };
}

export function getAccountsFailure(actionType) {
  return {
    type: actionType
  };
}

export function getAccountsReset() {
  return {
    type: ActionTypes.ACCOUNTS.RESET,
  };
}

export function getTransferCardTargetAccountsRequest(accountNum, grandParentAccountNumber) {
  return {
    type: ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.REQUEST,
    payload: {
      clientAccountId: accountNum,
      grandParentAccountNumber,
      contractSearchMethod: 'CONTRACT_NUMBER',
      pageSize: 0,
      outObjectPage: 0,
      sortBy: 'AccountLevel',
      sortOrder: 'Desc',
      searchTerm: '',
    },
  };
}

export function getTransferCardTargetAccountsSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.SUCCESS,
    payload: {
      accounts: response.getContractListByContract
    }
  };
}

export function getTransferCardTargetAccountsFailure() {
  return {
    type: ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.FAILURE
  };
}

export function getTransferCardTargetAccountsReset() {
  return {
    type: ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.RESET
  };
}

export function updateDetailsSearchTerm(value) {
  return {
    type: ActionTypes.ACCOUNTS.UPDATE.SEARCH_TERM,
    payload: {
      searchTerm: value,
    }
  };
}

export function detailsDownloadRequest(grandParentAccountNumber, contractIdentifier, searchTerm){
  return {
    type: ActionTypes.ACCOUNTS.DOWNLOAD.REQUEST,
    payload: {
      contractIdentifier,
      grandParentAccountNumber,
      searchTerm,
    }
  };
}

export function detailsDownloadFailure(){
  return {
    type: ActionTypes.ACCOUNTS.DOWNLOAD.FAILURE
  };
}

export function detailsDownloadSuccess(){
  return {
    type: ActionTypes.ACCOUNTS.DOWNLOAD.SUCCESS
  };
}

export function getAddressesByContract(contractIdentifier, assignedGrandfatherClientNumber) {
  return {
    type: ActionTypes.ADDRESSES.REQUEST,
    payload: {
      contractIdentifier: contractIdentifier,
      grandParentAccountNumber: assignedGrandfatherClientNumber,
    },
  };
}

export function updateAddressesByContract(payload) {
  return {
    type: ActionTypes.ADDRESSES.UPDATE.REQUEST,
    payload: payload,
  };
}

export function updateAddressesReset() {
  return {
    type: ActionTypes.ADDRESSES.UPDATE.RESET,
  };
}

export function getPaymentTypeRequest(grandParentAccountNumber, accountNumber) {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT_TYPE.REQUEST,
    payload: {
      grandParentAccountNumber,
      accountNumber,
    },
  };
}

export function getPaymentTypeSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT_TYPE.SUCCESS,
    payload: {
      response,
    },
  };
}

export function getPaymentTypeFailure() {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT_TYPE.FAILURE
  };
}

export function getPaymentTypeReset() {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT_TYPE.RESET
  };
}

export function makePaymentRequest(grandParentAccountNumber, accountNumber, amount) {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT.REQUEST,
    payload: {
      grandParentAccountNumber,
      accountNumber,
      contractSearchMethod: 'CONTRACT_NUMBER',
      reason: 'manual direct debit',
      amount,
      adjustmentTypeIDT: 8018
    },
  };
}

export function makePaymentSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT.SUCCESS,
    payload: {
      response,
    },
  };
}

export function makePaymentFailure() {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT.FAILURE
  };
}

export function makePaymentReset() {
  return {
    type: ActionTypes.ACCOUNTS.PAYMENT.RESET
  };
}

export function getInvoicesAction(grandParentAccountNumber, accountNumber, startDate, endDate, pageSize, startPage, sortField, sortDirection, reportName) {
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.REQUEST,
    payload:{
      grandParentAccountNumber,
      accountNumber,
      startDate,
      endDate,
      pageSize,
      startPage,
      sortField,
      sortDirection,
      reportName,
    }
  };
}

export function resetInvoicesAction() {
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.RESET
  };
}

export function getInvoicesSuccessAction(response) {
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.SUCCESS,
    payload: response
  };
}

export function getInvoicesFailureAction() {
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.FAILURE
  };
}

export function getInvoiceDocumentDownload(grandParentAccountNumber, contractIdentifier, documentId, fileType) {
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.REQUEST,
    payload:{
      grandParentAccountNumber: grandParentAccountNumber,
      contractIdentifier: contractIdentifier,
      documentId: documentId,
      fileType: fileType
    }
  };
}

export function detailsDownloadInvoiceFailure(){
  return {
    type: ActionTypes.ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.FAILURE
  };
}

export function getGrandparentAccountNameRequest(accountNumber) {
  return {
    type: ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.REQUEST,
    payload: {
      accountNumber,
    },
  };
}

export function getGrandparentAccountNameSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.SUCCESS,
    payload: {
      response,
    },
  };
}

export function getGrandparentAccountNameFailure() {
  return {
    type: ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.FAILURE
  };
}

export function getGrandparentAccountNameReset() {
  return {
    type: ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.RESET
  };
}

export function getContractBalancesRequest(accountNumber, assignedGrandfatherClientNumber) {
  return {
    type: ActionTypes.ACCOUNTS.CONTRACT_BALANCES.REQUEST,
    payload: {
      accountNumber: accountNumber,
      assignedGrandfatherClientNumber: assignedGrandfatherClientNumber
    },
  };
}

export function getContractBalancesSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.CONTRACT_BALANCES.SUCCESS,
    payload: {
      response,
    },
  };
}

export function getContractBalancesFailure() {
  return {
    type: ActionTypes.ACCOUNTS.CONTRACT_BALANCES.FAILURE
  };
}

export function getAcquiringContractAddress(contractIdentifier) {
  return {
    type: ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.REQUEST,
    payload: {
      contractIdentifier
    },
  };
}

export function getAcquiringContractAddressSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.SUCCESS,
    payload: {
      response,
    },
  };
}

export function getAcquiringContractAddressFailure() {
  return {
    type: ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.FAILURE
  };
}

export function getAccountsForUser(userId, accountNumber, pageSize, pageNumber, sortColumn, sortDirection) {
  return {
    type: ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.REQUEST,
    payload: {
      userId,
      accountNumber,
      pageSize,
      pageNumber,
      sortColumn,
      sortDirection
    },
  };
}

export function getAccountsForUserSuccess(response) {
  return {
    type: ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.SUCCESS,
    payload: {
      getAccountsForUserResult: response
    },
  };
}

export function getAccountsForUserFailure() {
  return {
    type: ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.FAILURE
  };
}

export function getAccountsForUserReset() {
  return {
    type: ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.RESET
  };
}
